<script>
export default {
    props: {
        activeImageIndex: { type: Number, required: true, },
        images: { type: Array, required: true, }
    },

    emits: [
        'update:activeImageIndex'
    ],

    computed: {
        farLeftImageIndex() { 
            let index = this.activeImageIndex - 2;
            return this.getNegativeOffsetIndex(index);
        },
        leftImageIndex() { 
            let index = this.activeImageIndex - 1;
            return this.getNegativeOffsetIndex(index);
        },
        rightImageIndex() {
            let index = this.activeImageIndex + 1;
            return this.getPositiveOffsetIndex(index);
        },

        farRightImageIndex() { 
            let index = this.activeImageIndex + 2;
            return this.getPositiveOffsetIndex(index)
        }
    },

    methods: {
        emit(index) {
            this.$emit('update:activeImageIndex', index);
        },
        getNegativeOffsetIndex(index) {
            return index < 0
                ? this.images.length - (Math.abs(index))
                : index
        },
        getPositiveOffsetIndex(index) {
            return index > this.images.length - 1
                ? index - (this.images.length)
                : index;
        }
    }
}
</script>

<template>
    <p
        v-if="images.length < 1"
    >
        Geen afbeeldingen aanwezig
    </p>
    <div
        class="image-list d-flex gap-2"
    >
        <img
            v-if="farLeftImageIndex !== null"
            class="image far-left"
            :src="images[farLeftImageIndex]"
            @click.prevent="emit(farLeftImageIndex)"
        />
        <img
            v-if="leftImageIndex != null"
            class="image left"
            :src="images[leftImageIndex]"
            @click.prevent="emit(leftImageIndex)"

        />
        <img
            class="image center"
            :src="images[activeImageIndex]"
        />
        <img
            v-if="rightImageIndex != null"
            class="image right"
            :src="images[rightImageIndex]"
            @click.prevent="emit(rightImageIndex)"
        />
        <img
            v-if="farRightImageIndex != null"
            class="image far-right"
            :src="images[farRightImageIndex]"
            @click.prevent="emit(farRightImageIndex)"
        />
    </div>
</template>

<style lang="scss" scoped>

.image-list {
    padding-block: 10px;

    .image {
        cursor:pointer;
        height: 100px;

         border-radius: 10px;

        &.center {
            outline: 2px solid #fff;
            border-radius: 10px;
        }
    }
}
</style>